import React, { useEffect, useState } from 'react';
import HizmetEkleModal from '../components/HizmetEkleModal';
import SayiDuzenleModal from '../components/SayiDuzenleModal';
import KumulatifOzet from '../components/KumulatifOzet';
import { getTarifeListesi } from '../services/api';
import { grupRenkleri, stokRengi } from '../utils/renkler';
import { paraFormat, hesaplaBirimFiyat, hesaplaKumulatif } from '../utils/fiyat';

// Satır zemin rengi: stok kalemleri sabit stokRengi, hizmet kalemleri GRUPKOD'a göre grupRenkleri
// (Kabul İşlemleri ile aynı renk şeması) — kullanıcı talebi: 2026-08-09 (mobilde dar ekrana sığması
// için Kod/Türü sütunları kaldırılıp yerine bu renk kodlaması getirildi).
const satirRengi = (h) => h.kaynak === 'stok' ? stokRengi : (grupRenkleri[h.grupKod] || 'transparent');

// Liste tablo yapısında gösterilirken kullanılan ortak th/td stilleri — Kabul İşlemleri ile aynı
// (kullanıcı talebi: 2026-08-09).
const tabloBaslikStil = { textAlign: 'left', padding: '7px 12px', background: '#f8faf9', border: '1px solid var(--border)', fontSize: 11, color: 'var(--text-muted)', fontWeight: 600 };
const tabloHucreStil = { padding: '8px 12px', border: '1px solid var(--border)', fontSize: 13 };

// "Fiyat Ver": seçilen hizmetleri sadece ekran hafızasında tutan, hiçbir tabloya kaydetmeyen bir
// fiyat/fatura önizleme ekranı. Amaç: müşteriye fiyat bilgisi verebilmek için hizmetleri geçici
// olarak bir araya toplamak (kullanıcı talebi: 2026-08-08). Tutar = Adet x B.Fiyat her render'da
// hesaplanır, ayrı bir state değil. B.Fiyat hesabı artık Kabul İşlemleri ile paylaşılan
// utils/fiyat.js'de (kullanıcı talebi: 2026-08-09).

export default function FiyatVer() {
  const [liste, setListe] = useState([]);
  const [seciliIndex, setSeciliIndex] = useState(null);
  const [ekleModalAcik, setEkleModalAcik] = useState(false);

  const [tarifeler, setTarifeler] = useState([]);
  const [seciliTarife, setSeciliTarife] = useState(null);

  // Adet/B.Fiyat düzenleme popup'ı: tip 'adet' | 'fiyat', hangi satır (index) ve o an yazılan değer.
  const [editModal, setEditModal] = useState(null);

  useEffect(() => {
    getTarifeListesi().then(res => {
      setTarifeler(res.data);
      if (res.data.length > 0) setSeciliTarife(res.data[0]);
    }).catch(err => console.error(err));
  }, []);

  const hizmetlerEkle = (kayitlar) => {
    setListe(prev => [...prev, ...kayitlar.map(k => ({ ...k, adet: k.adet ?? 1, birimFiyat: hesaplaBirimFiyat(k, seciliTarife) }))]);
    setEkleModalAcik(false);
  };

  const tarifeDegisti = (e) => {
    const kod = parseInt(e.target.value, 10);
    const yeniTarife = tarifeler.find(t => t.kod === kod) || null;
    setSeciliTarife(yeniTarife);
    setListe(prev => prev.map(h => ({ ...h, birimFiyat: hesaplaBirimFiyat(h, yeniTarife) })));
  };

  const sil = () => {
    if (seciliIndex === null) return;
    setListe(prev => prev.filter((_, i) => i !== seciliIndex));
    setSeciliIndex(null);
  };

  const temizle = () => {
    setListe([]);
    setSeciliIndex(null);
  };

  const satiraTikla = (i) => {
    setSeciliIndex(prev => (prev === i ? null : i));
  };

  // --- Adet düzenleme: sadece rakam, en fazla 3 hane (max 999) ---

  const adetDuzenlemeyeBasla = (e, i) => {
    e.stopPropagation();
    setEditModal({ tip: 'adet', index: i, deger: String(liste[i].adet) });
  };

  const adetDegisti = (e) => {
    const sadeceRakam = e.target.value.replace(/\D/g, '').slice(0, 3);
    setEditModal(prev => ({ ...prev, deger: sadeceRakam }));
  };

  const adetKaydet = () => {
    const yeniAdet = parseInt(editModal.deger, 10);
    const idx = editModal.index;
    setListe(prev => prev.map((h, i) => i === idx ? { ...h, adet: (Number.isFinite(yeniAdet) && yeniAdet > 0) ? yeniAdet : 1 } : h));
    setEditModal(null);
  };

  // --- B.Fiyat düzenleme: TL formatında (1.234.567,89), tam kısım en fazla 7 hane (max 9.999.999) ---

  const fiyatDuzenlemeyeBasla = (e, i) => {
    e.stopPropagation();
    setEditModal({ tip: 'fiyat', index: i, deger: paraFormat(liste[i].birimFiyat) });
  };

  const fiyatDegisti = (e) => {
    const girdi = e.target.value.replace(/[^\d,]/g, '');
    const virgulIndex = girdi.indexOf(',');
    const tamKisimHam = (virgulIndex === -1 ? girdi : girdi.slice(0, virgulIndex)).slice(0, 7);
    const kusuratHam = (virgulIndex === -1 ? '' : girdi.slice(virgulIndex + 1).replace(/,/g, '')).slice(0, 2);

    const tamFormatli = tamKisimHam === ''
      ? (virgulIndex !== -1 ? '0' : '')
      : Number(tamKisimHam).toLocaleString('tr-TR');

    const yeniDeger = virgulIndex === -1 ? tamFormatli : `${tamFormatli},${kusuratHam}`;
    setEditModal(prev => ({ ...prev, deger: yeniDeger }));
  };

  const fiyatKaydet = () => {
    const normalize = editModal.deger.replace(/\./g, '').replace(',', '.');
    const deger = parseFloat(normalize);
    const idx = editModal.index;
    setListe(prev => prev.map((h, i) => i === idx ? { ...h, birimFiyat: (Number.isFinite(deger) && deger >= 0) ? deger : 0 } : h));
    setEditModal(null);
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <h2 style={{ fontSize: 14, fontWeight: 600 }}>Fiyat Ver</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn btn-primary" style={{ fontSize: 12, padding: '6px 12px' }} onClick={() => setEkleModalAcik(true)}>➕ Ekle</button>
          <button
            className="btn"
            style={{ fontSize: 12, padding: '6px 12px', background: '#c0392b', color: '#fff', border: 'none', opacity: seciliIndex === null ? 0.5 : 1 }}
            onClick={sil}
            disabled={seciliIndex === null}
          >
            🗑 Sil
          </button>
          <button
            className="btn btn-secondary"
            style={{ fontSize: 12, padding: '6px 12px', opacity: liste.length === 0 ? 0.5 : 1 }}
            onClick={temizle}
            disabled={liste.length === 0}
          >
            🧹 Temizle
          </button>
        </div>
      </div>

      <div style={{ marginBottom: 12 }}>
        <label style={{ fontSize: 11, fontWeight: 600, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>Tarife</label>
        <select value={seciliTarife?.kod ?? ''} onChange={tarifeDegisti} style={{ minWidth: 260 }}>
          {tarifeler.map(t => (
            <option key={t.kod} value={t.kod}>{t.tarifeAdi}</option>
          ))}
        </select>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {liste.length === 0 ? (
          <div className="empty">Henüz hizmet eklenmedi</div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={tabloBaslikStil}>Hizmet / Stok Adı</th>
                  <th style={{ ...tabloBaslikStil, textAlign: 'right', width: 55 }}>Adet</th>
                  <th style={{ ...tabloBaslikStil, textAlign: 'right', width: 110 }}>B.Fiyat</th>
                  <th style={{ ...tabloBaslikStil, textAlign: 'right', width: 110 }}>Tutar</th>
                </tr>
              </thead>
              <tbody>
                {liste.map((h, i) => (
                  <tr
                    key={i}
                    onClick={() => satiraTikla(i)}
                    style={{ cursor: 'pointer', background: seciliIndex === i ? 'var(--med-light)' : satirRengi(h) }}
                  >
                    <td style={tabloHucreStil}>{h.butAdi}</td>

                    <td onClick={e => adetDuzenlemeyeBasla(e, i)} style={{ ...tabloHucreStil, textAlign: 'right', textDecoration: 'underline dotted', cursor: 'pointer' }}>
                      {h.adet}
                    </td>

                    <td onClick={e => fiyatDuzenlemeyeBasla(e, i)} style={{ ...tabloHucreStil, textAlign: 'right', textDecoration: 'underline dotted', cursor: 'pointer' }}>
                      {paraFormat(h.birimFiyat)}
                    </td>

                    <td style={{ ...tabloHucreStil, textAlign: 'right', fontWeight: 500 }}>{paraFormat(h.adet * h.birimFiyat)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {liste.length > 0 && <KumulatifOzet {...hesaplaKumulatif(liste)} />}

      {ekleModalAcik && (
        <HizmetEkleModal
          onKapat={() => setEkleModalAcik(false)}
          onKaydet={hizmetlerEkle}
          kaydetMetni="EKLE"
          kaydediliyorMetni="Ekleniyor..."
        />
      )}

      {editModal?.tip === 'adet' && (
        <SayiDuzenleModal
          baslik="Adet"
          deger={editModal.deger}
          onDeger={adetDegisti}
          onTamam={adetKaydet}
          onKapat={() => setEditModal(null)}
          numerik="tam"
        />
      )}

      {editModal?.tip === 'fiyat' && (
        <SayiDuzenleModal
          baslik="Birim Fiyat"
          deger={editModal.deger}
          onDeger={fiyatDegisti}
          onTamam={fiyatKaydet}
          onKapat={() => setEditModal(null)}
          numerik="ondalik"
        />
      )}
    </div>
  );
}
